module.exports = __webpack_public_path__ + "static/media/icon-doc.6b547c65.svg";